/**
 * Tab notification
 */
window.addEventListener('load', () => {
  const originalTitle = document.title;
  const alternateTitles = ['🥊 Where did you go?', 'I need you in my corner! 🏆'];
  const updateDelay = 1500;
  let currentTitleIndex = 0;
  let titleTimer;

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      titleTimer = setTimeout(function updateTitle() {
        document.title = alternateTitles[currentTitleIndex++];
        if (alternateTitles.length === currentTitleIndex) currentTitleIndex = 0;
        titleTimer = setTimeout(updateTitle, updateDelay);
      }, updateDelay);
    } else {
      clearInterval(titleTimer);
      currentTitleIndex = 0;
      document.title = originalTitle;
    }
  });
});

/**
 * PD Marquee
 */
customElements.define(
  'pd-marquee',
  class PD_Marquee extends HTMLElement {
    constructor() {
      super();

      this.isAnimating = false;
      this.classes = {
        animated: 'pd-marquee--animated',
        animate: 'pd-marquee--animate',
      };

      // Make configurable later
      this.classList.add(this.classes.animated);
      this.texts = this.querySelector('.pd-marquee__texts');
      this.texts.insertAdjacentHTML('beforeend', this.texts.innerHTML + this.texts.innerHTML);

      window.addEventListener('load', this.animate.bind(this));

      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.reset();
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.reset();
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.pause();
      });
    }

    animate() {
      this.classList.add(this.classes.animate);
      this.isAnimating = true;
    }

    pause() {
      this.classList.remove(this.classes.animated, this.classes.animate);
      this.isAnimating = false;
    }

    reset() {
      this.pause();
      this.animate();
    }
  },
);

/**
 * PD Sliding Gallery
 */
customElements.define(
  'pd-sliding-gallery',
  class PD_SlidingGallery extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        clone: 'pd-sliding-gallery__images--clone',
        animated: 'pd-sliding-gallery--animated',
        animate: 'pd-sliding-gallery--animate',
        reveal: 'pd-sliding-gallery--reveal',
      };

      this.images = this.querySelector('.pd-sliding-gallery__images');
      this.images.addEventListener('animationend', this.rewind.bind(this));
      this.images.lastElementChild.addEventListener('transitionend', this.animate.bind(this));

      // this.clone = this.images.cloneNode(true);
      // this.clone.classList.add(this.classes.clone);
      // this.append(this.clone);

      new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            entries[0].target.classList.add(this.classes.reveal);
            observer.disconnect();
          }
        },
        { threshold: 1 },
      ).observe(this);

      window.addEventListener('load', this.reset.bind(this));
      window.addEventListener('resize', this.reset.bind(this));
    }

    animate() {
      if (!this.classList.contains(this.classes.reveal)) return;
      this.classList.add(this.classes.animate);
    }

    rewind() {
      this.classList.remove(this.classes.reveal, this.classes.animate);
      setTimeout(() => this.classList.add(this.classes.reveal), 100);
    }

    reset() {
      this.classList.remove(this.classes.animated);
      this.style = '';

      const style = getComputedStyle(this);
      this.style.height = style.height;
      this.classList.add(this.classes.animated);
      // this.clone.style.left = `${this.images.offsetWidth + this.images.offsetLeft}px`;
    }
  },
);

/**
 * PD FAQ List
 */
customElements.define(
  'pd-faq',
  class PD_Faq extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        if (!event.target.matches('h3')) return;
        event.target.closest('li').classList.toggle('open');
      });
    }
  },
);

/**
 * Road Rage
 */
customElements.define(
  'road-rage',
  class PD_RoadRage extends HTMLElement {
    constructor() {
      super();

      window.addEventListener('load', () => {
        new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;

            const underlined = this.hasAttribute('underlined');
            const lottie = entries[0].target.querySelector('lottie-player');

            if (lottie) {
              if (underlined) {
                const halfway = lottie.getLottie().totalFrames / 2;
                lottie.addEventListener('frame', (event) => {
                  if (event.detail.frame >= halfway) {
                    entries[0].target.classList.add('animate');
                  }
                });
              }

              lottie.play();
            } else if (underlined) {
              entries[0].target.classList.add('animate');
            }

            observer.disconnect();
          },
          {
            // rootMargin: "0% 0% -40% 0%",
            threshold: 1.0,
          },
        ).observe(this);
      });
    }
  },
);

/**
 * What's inside? opener animation
 */
window.addEventListener('load', () => {
  const opener = document.querySelector('.product-popup-modal__opener--whats-inside .link');
  if (opener) {
    opener.addEventListener('animationend', () => {
      opener.classList.remove('animate');
      setTimeout(() => opener.classList.add('animate'), 30000);
    });
    setTimeout(() => opener.classList.add('animate'), 30000);
  }
});

/**
 * Slider component
 */
customElements.define(
  'pd-slider-component',
  class PD_SliderComponent extends SliderComponent {
    constructor() {
      super();

      this.dotNav = this.querySelector('.pd-slider-dots');
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      if (!this.dotNav || !this.sliderControlWrapper) return;

      // Hide controls
      this.sliderControlWrapper.classList.add('hidden');
    }

    // this.totalPages
    // this.currentPage

    initPages() {
      super.initPages();
      if (!this.dotNav) return;

      const dots = new DocumentFragment();

      for (let i = 1; i <= this.totalPages; i++) {
        const dot = document.createElement('div');
        if (i === 1) dot.classList.add('active');
        dot.dataset.index = i;
        dot.textContent = i;
        dots.append(dot);
      }

      this.dotNav.replaceChildren(dots);
    }

    update() {
      super.update();
      if (!this.dotNav) return;

      this.dotNav.querySelector('.active')?.classList.remove('active');
      this.dotNav.querySelector(`[data-index="${this.currentPage}"]`)?.classList.add('active');
    }
  },
);

/**
 * Star rating
 */
window.addEventListener('DOMContentLoaded', () => {
  const widget = document.getElementById('shopify-block-9452549a-dd4d-4c8f-9b0a-d696a4b5f0e7');

  if (widget) {
    new MutationObserver((mutations, observer) => {
      for (const mutation of mutations) {
        const rating = mutation.target.querySelector('.yotpo-sr-bottom-line-text');
        if (rating) {
          rating.setAttribute('data-content', Number(rating.innerText) === 1 ? 'REVIEW' : 'REVIEWS');
          observer.disconnect();
        }
      }
    }).observe(widget, { childList: true, subtree: true });
  }
});

/**
 * Lab report PDF
 */
window.addEventListener('load', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const opener = document.querySelector('.product-popup-modal__opener--lab-report');

    if (!opener) return;

    const button = opener.querySelector('.product-popup-modal__button');
    const content = document.querySelector('.product-popup-modal__content-info');
    const source = event.data.html.getElementById('LabReportPdf');

    button.classList.remove('animate');

    if (source) {
      content.innerHTML = source.outerHTML;
      opener.classList.remove('visually-hidden');
      setTimeout(() => {
        button.classList.add('animate');
      }, 0);
    } else {
      opener.classList.add('visually-hidden');
    }
  });
});

/**
 * Back-In-Stock button
 */
window.addEventListener('load', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const bis = document.getElementById('BIS_trigger');

    if (!bis) return;

    if (event.data.variant.available) {
      bis.setAttribute('disabled', 'disabled');
    } else {
      bis.dataset.variantId = event.data.variant.id;
      bis.removeAttribute('disabled');
    }
  });
});

/**
 * ATC button icon
 */
window.addEventListener('load', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const atc = document.querySelector('[name="add"] > span');

    if (atc && event.data.variant.available) {
      atc.innerHTML = `${window.icons.shoppingBag} ${window.variantStrings.addToCart}`;
    }
  });
});

/**
 * Countdown timer component.
 */
customElements.define(
  'pd-countdown',
  class PD_Countdown extends HTMLElement {
    constructor() {
      super();

      this.expiry = new Date(this.dataset.expiry).getTime();
      this.originalContent = this.textContent;
    }

    connectedCallback() {
      if (!this.expiry) return;

      this.timer = setInterval(() => {
        const now = new Date().getTime();
        const duration = this.expiry - now;
        const d = Math.floor(duration / (1000 * 60 * 60 * 24));
        const h = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((duration % (1000 * 60)) / 1000);

        this.textContent = `${d}d ${h}h ${m}m ${s}s`;

        if (duration < 0) {
          clearInterval(this.timer);
          this.textContent = this.originalContent;
        }
      }, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  },
);

/**
 * PD Upsell
 */
customElements.define(
  'pd-upsell',
  class PD_Upsell extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      const data = event.target.options[event.target.selectedIndex].dataset;
      const item = event.target.closest('.pd-upsell__item');

      item.querySelector('.pd-upsell__price').innerText = data.price;
      item.querySelector('.pd-upsell__heading > span').innerText = event.target.options[event.target.selectedIndex].innerText;

      if (data.imageUrl !== '') {
        item.querySelector('.pd-upsell__image').srcset = data.imageUrl;
      }

      const compareAtPrice = item.querySelector('.pd-upsell__compare-at-price');

      if (data.price.replace(/[^\d]/g, '') < data.compareAtPrice.replace(/[^\d]/g, '')) {
        compareAtPrice.innerText = data.compareAtPrice;
        compareAtPrice.classList.remove('hidden');
      } else {
        compareAtPrice.classList.add('hidden');
      }
    }

    onSubmit(event) {
      event.preventDefault();

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const form = event.target;
      const button = form.querySelector('[name="add"]');

      this.handleError(form);

      button.disabled = true;
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleError(form, response.description);
            return;
          } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          cart.renderContents(response);
          form.closest('.pd-upsell__item').classList.add('hidden');
          if (!this.querySelectorAll('.pd-upsell__item:not(.hidden)').length) {
            this.classList.add('hidden');
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          button.disabled = false;
          button.classList.remove('loading');
          button.setAttribute('aria-disabled', 'false');
          button.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }

    handleError(form, msg = false) {
      form.parentElement.querySelector('.pd-upsell__item__errors').toggleAttribute('hidden', !msg);
      if (msg) form.parentElement.querySelector('.pd-upsell__error-msg').textContent = msg;
    }
  },
);

/**
 * Play video on page load
 */
window.addEventListener('load', () => {
  document.querySelectorAll('[data-video-autoplay="true"]').forEach((video) => {
    video.loadContent(false);
  });
});
